/** Best timestamp for display / sort (latest activity first). */
export function getInstructionTimestamp(it) {
    if (!it || typeof it !== 'object') return null;
    return it.modified_timestamp
        || it.creation_timestamp
        || it.created
        || it.createdAt
        || null;
}

/** Newest first — by modified, then created. */
export function sortInstructionsNewestFirst(items) {
    const ts = (it) => {
        const t = new Date(getInstructionTimestamp(it) || 0).getTime();
        return Number.isFinite(t) ? t : 0;
    };
    return [...(items || [])].sort((a, b) => ts(b) - ts(a));
}
